export default "__VITE_ASSET__iWQFAFXP__"